<span class="status-badge" [ngClass]="config().cssClass">
  <lucide-icon [name]="config().icon" [size]="16" [strokeWidth]="2" />
  {{ config().label | labelsProvider }}
</span>
